// extracted by mini-css-extract-plugin
export default {"container":"zm5He_container","shopName":"pM08H_shopName"};